<template>
  <ListagemBase
    ref="listagem"
    :nomePlural="isOrgaoPublico ? 'Servidores' : 'Funcionarios'"
    nomeSingular="Funcionario"
    :headers="headersExibicao"
    :buscaParametrizadaPaginada="true"
    stringCadastro="Admissao"
    :buscaSimplificada="false"
    :pesquisaMatricula="true"
    :pesquisaNome="true"
    :pesquisaClienteLike="true"
    :pesquisaPostoTrabalhoLike="true"
    :botaoCadastro="!modoSelecaoRecurso"
    :editar="!modoSelecaoRecurso"
    :botaoTransferenciaEmpresaFuncionario="!modoSelecaoRecurso"
    :importacaoExcel="modoSelecaoRecurso ? null : importacaoExcel"
    :botaoImportDexion="!modoSelecaoRecurso && possuiIntegracaoDexion"
    :pesquisaStatusFuncionarioFiltro="true"
    :modoSelecaoRecurso="modoSelecaoRecurso"
    :ocultarCabecalhoListagem="modoSelecaoRecurso"
    :keyboardShortcutsEnabled="!modoSelecaoRecurso"
    :class="{ 'listagem-modo-selecao': modoSelecaoRecurso }"
    @row-click="selecionarRecurso"
  >
    <template v-if="!modoSelecaoRecurso" v-slot:upload>
      <AtualizacaoFuncionarioLote @concluido="atualizacaoConcluida" />
    </template>
    <template v-if="!modoSelecaoRecurso" v-slot:item.actions-extra="{ item }">
      <v-menu v-if="lembretesDisponiveis(item).length" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="tooltip">
              <v-btn
                v-can="'ROLE_Funcionario_Update'"
                icon
                small
                color="primary"
                :disabled="enviandoLembrete"
                :aria-label="$t('simular_lembrete_jornada')"
                v-bind="{ ...attrs, ...tooltip.attrs }"
                v-on="{ ...on, ...tooltip.on }"
                @click.stop
              >
                <v-icon small>mdi-bell-ring-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('simular_lembrete_jornada') }}</span>
          </v-tooltip>
        </template>
        <v-list dense>
          <v-subheader>{{ $t('simular_lembrete_jornada') }}</v-subheader>
          <v-list-item
            v-for="opcao in lembretesDisponiveis(item)"
            :key="opcao.tipo"
            @click.stop="confirmarLembrete(item, opcao)"
          >
            <v-list-item-icon class="mr-2"><v-icon small>{{ opcao.icone }}</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(opcao.rotulo) }}</v-list-item-title>
              <v-list-item-subtitle v-if="opcao.horario">{{ opcao.horario }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </ListagemBase>
</template>

<script>
import FuncionarioDataService from "@/services/pessoal/FuncionarioDataService";
const DataService = FuncionarioDataService;

import ListagemBase from "@/components/base/Crud/ListagemBase";
import AtualizacaoFuncionarioLote from "@/components/pessoal/funcionarios/AtualizacaoFuncionarioLote";
import { configuracaoImportacaoExcel } from "@/utils/importacaoExcel";

export default {
  name: "ListagemFuncionarios",
  components: { ListagemBase, AtualizacaoFuncionarioLote },
  props: {
    modoSelecaoRecurso: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      DataService: DataService,

      //Recurso
      deleted: [],
      funcionarios: [],
      enviandoLembrete: false,
    };
  },
  methods: {
    lembretesDisponiveis(item) {
      if (!item.funcionarioEscalaTrabalho) return [];
      const dias = ["DOMINGO", "SEGUNDA", "TERCA", "QUARTA", "QUINTA", "SEXTA", "SABADO"];
      const diasEscala = item.funcionarioEscalaTrabalho.funcionarioEscalaTrabalhoDiaSemana;
      const escalaHoje = Array.isArray(diasEscala)
        ? diasEscala.find((dia) => dia.diaSemana === dias[new Date().getDay()])
        : null;
      const horarios = escalaHoje?.funcionarioEscalaTrabalhoDiaSemanaHorarios || [];
      if (Array.isArray(diasEscala) && !horarios.length) return [];
      const params = this.$store?.state?.inquilino?.parametrizacoes || [];
      const ativo = (tipo) => params.some((param) => param.tipo === tipo && param.ativo === true);
      return [
        { tipo: "INICIO", configuracao: "APPALERTAINICIOJORNADA", rotulo: "lembrete_inicio_jornada", icone: "mdi-login", horario: horarios[0]?.horario?.slice(0, 5) },
        { tipo: "ENCERRAMENTO", configuracao: "APPALERTAENCERRAMENTOJORNADA", rotulo: "lembrete_fim_jornada", icone: "mdi-logout", horario: horarios.length > 1 ? horarios[horarios.length - 1]?.horario?.slice(0, 5) : null },
      ].filter((opcao) => ativo(opcao.configuracao) && (!Array.isArray(diasEscala) || opcao.horario));
    },
    async confirmarLembrete(item, opcao) {
      if (this.enviandoLembrete) return;
      const nome = item.nomeSocial || item.pessoa?.nome || item.matricula;
      const confirmacao = await this.$swal.fire({
        icon: "question",
        title: this.$t("simular_lembrete_jornada"),
        text: this.$t("confirmar_envio_lembrete_jornada", { tipo: this.$t(opcao.rotulo), nome }),
        showCancelButton: true,
        confirmButtonText: this.$t("Enviar"),
        cancelButtonText: this.$t("Cancelar"),
      });
      if (!confirmacao.isConfirmed) return;
      this.enviandoLembrete = true;
      try {
        await FuncionarioDataService.enviarLembreteJornada(item.id, opcao.tipo);
        await this.$swal.fire({ icon: "success", text: this.$t("lembrete_jornada_enviado") });
      } catch (error) {
        const mensagem = error.response?.status === 422 && error.response?.data?.message
          ? error.response.data.message
          : this.$t("lembrete_jornada_erro");
        await this.$swal.fire({ icon: "error", text: mensagem });
      } finally {
        this.enviandoLembrete = false;
      }
    },
    selecionarRecurso(payload) {
      if (this.modoSelecaoRecurso && payload && payload.item) {
        this.$emit("selecionar-recurso", payload.item);
      }
    },
    atualizacaoConcluida() {
      if (this.$refs.listagem) {
        this.$refs.listagem.retrieveData();
      }
    },
  },
  computed: {
    headersExibicao() {
      return this.modoSelecaoRecurso
        ? this.headers.filter((header) => header.value !== "actions")
        : this.headers;
    },
    isOrgaoPublico() {
      return this.$store?.state?.inquilino?.tipoContratacao === "ORGAOPUBLICO";
    },
    possuiIntegracaoDexion() {
      // O arquivo .txt da folha Dexion segue no fluxo próprio; o cadastro em massa usa o Excel.
      return (this.$store?.state?.inquilino?.parametrizacoes || []).some(
        (item) => item.tipo === "INTEGRACAOFPDEXION"
      );
    },
    importacaoExcel() {
      const gestaoEfetivo = ["GESTAOEFETIVO", "GESTAOEFETIVOPLUS"].includes(
        this.$store?.state?.inquilino?.tipoContratacao
      );
      return configuracaoImportacaoExcel(this, "admissoes", {
        nomeArquivo: "admissoes-cadastro.xlsx",
        colunas: [
          "linha",
          "matricula",
          "nome",
          "cpf",
          "admissao",
          "contrato",
          "email",
          "cidade",
        ],
        params: {
          gestaoEfetivo: gestaoEfetivo
            ? this.$t("importacaoExcel.admissoes.orientacaoGestaoEfetivo")
            : "",
        },
      });
    },
    headers() {
      const headers = [
        { text: this.$t("Matricula"), value: "matricula", sortable: "false" },
        { text: this.$t("Nome"), value: "nomeSocial", sortable: "false" },
        {
          text: this.$t("Sindicato"),
          value: "sindicato.descricao",
          sortable: "false",
        },
        {
          text: this.$t("Escala"),
          value: "funcionarioEscalaTrabalho.descricao",
          sortable: "false",
        },
        { text: this.$t("Cargo"), value: "cargo.descricao", sortable: "false" },
      ];
      if (this.isOrgaoPublico) {
        headers.push({
          text: this.$t("Servidor_categoria"),
          value: "servidorCategoria",
          sortable: "false",
        });
        headers.push({
          text: this.$t("Lotacao"),
          value: "cliente.fantasia",
          sortable: "true",
        });
      }
      headers.push(
        {
          text: this.$t(
            this.isOrgaoPublico ? "LocalTrabalho" : "PostoTrabalho"
          ),
          value: "postoTrabalho.descricao",
          sortable: "true",
        },
        { text: this.$t("Status"), value: "status", sortable: "false" },
        { text: this.$t("Acoes"), value: "actions", sortable: false }
      );
      return headers;
    },
  },
};
</script>

<style scoped>
.listagem-modo-selecao::v-deep tbody tr {
  cursor: pointer;
}
</style>
